"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (theme) {
    return {
        animationBackgroundColor: theme.elLight,
        color: theme.tAccent,
        borderColor: theme.elPrimary,
        background: theme.elPrimary,

        focusColor: theme.tAccent,
        focusBorderColor: theme.elPrimary,
        focusBackground: theme.elPrimary,

        hoverColor: theme.tAccent,
        hoverBorderColor: theme.elLightest,
        hoverBackground: theme.elLightest,

        activeColor: theme.tAccent,
        activeBorderColor: theme.elPrimary,
        activeBackground: theme.elPrimary,

        disabledColor: theme.tDisabled,
        disabledBorderColor: theme.elDivider,
        disabledBackground: theme.elDivider
    };
};